import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Grow,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import GridOnIcon from '@mui/icons-material/GridOn'
import DescriptionIcon from '@mui/icons-material/Description'
import GetAppIcon from '@mui/icons-material/GetApp'
import { useEffect, useRef, useState } from 'react'
import { HtmlTooltip } from '../../../components/Tooltip/HtmlTooltip'

export interface ExportToFileProps {
  convertToXLS: () => void
  convertToCSV: () => void
  setCustomerWithAddress?: React.Dispatch<React.SetStateAction<boolean>>
  customerWithAddress?: boolean
}

export const ExportToFile = ({
  convertToCSV,
  convertToXLS,
  setCustomerWithAddress,
  customerWithAddress,
}: ExportToFileProps) => {
  const [open, setOpen] = useState(false)
  const anchorRef = useRef<HTMLButtonElement>(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }
    const target = event.target as HTMLElement
    if (target.closest('.preventClose')) {
      return
    }

    setOpen(false)
  }

  function handleListKeyDown(event: React.KeyboardEvent) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    } else if (event.key === 'Escape') {
      setOpen(false)
    }
  }

  const prevOpen = useRef(open)
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current!.focus()
    }

    prevOpen.current = open
  }, [open])

  return (
    <Box style={{ marginLeft: 'auto' }}>
      <Button
        ref={anchorRef}
        id="composition-button"
        aria-controls={open ? 'composition-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        endIcon={
          <img
            src="/assets/icons/downloads/download.svg"
            alt="download-icon-sells"
          />
        }
        sx={{ textTransform: 'none' }}
      >
        <Typography
          color="rgba(99, 126, 239, 1)"
          fontFamily={'Montserrat'}
          fontSize={'14px'}
          lineHeight={'18px'}
          fontWeight={500}
        >
          Exportar
        </Typography>
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="left-end"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }: any) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom-start' ? 'left top' : 'left bottom',
            }}
          >
            <Paper>
              {setCustomerWithAddress !== undefined && (
                <Stack direction={'row'} alignItems={'center'}>
                  <Checkbox
                    className="preventClose"
                    checked={customerWithAddress || false}
                    onChange={(e) => {
                      if (setCustomerWithAddress) {
                        setCustomerWithAddress(e.target.checked)
                      }
                    }}
                    color="primary"
                  />
                  <Typography>Endereço do cliente</Typography>
                  <HtmlTooltip title="Os dados do endereço do cliente serão adicionados no relatorio">
                    <img
                      src="/assets/icons/infos/info.svg"
                      alt="tooltip-info-pixel"
                      style={{ marginLeft: 5 }}
                    />
                  </HtmlTooltip>
                </Stack>
              )}
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem
                    onClick={(e) => {
                      convertToXLS()
                      handleClose(e)
                    }}
                  >
                    <ListItemIcon>
                      <GridOnIcon />
                    </ListItemIcon>
                    <ListItemText primary="Excel" />
                  </MenuItem>
                  <MenuItem
                    onClick={(e) => {
                      convertToCSV()
                      handleClose(e)
                    }}
                  >
                    <ListItemIcon>
                      <DescriptionIcon />
                    </ListItemIcon>
                    <ListItemText primary="CSV" />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Box>
  )
}
